export default __webpack_public_path__ + "static/media/person_3@2x.b0ea5995.png";